import React from 'react';

const HelpSupport = () => {
    return (
        <div className="help-support">
            <h1>MODULO NO FUNCIONAL - EN ETAPA DE DESARROLLO</h1>
            <h2>Ayuda y Soporte</h2>
            <section>
                <p>-----ToDo----</p>
            </section>
            <section>
                <h3>Contacto</h3>
                <p>Para asistencia adicional, por favor contactar a soporte@medellin.gov.co</p>
            </section>
        </div>
    );
};

export default HelpSupport;
